import React, { Suspense } from "react";
import { Switch, Route } from "react-router-dom";

import Layout from "./components/Layout/Layout";
import LoadingSpinner from "./components/UI/LoadingSpinner";

const HomePage = React.lazy(() => import("./pages/HomePage"));
const PrivacyPage = React.lazy(() => import("./pages/PrivacyPage"));
const CodesPage = React.lazy(() => import("./pages/CodesPage"));
const PicosMorse = React.lazy(() => import("./pages/PicosMorse"));
const Transposto = React.lazy(() => import("./pages/Transposto"));
const BraileFalso = React.lazy(() => import("./pages/BraileFalso"));
const BraileVerdadeiro = React.lazy(() => import("./pages/BraileVerdadeiro"));
const CodigoData = React.lazy(() => import("./pages/CodigoData"));
const Morse = React.lazy(() => import("./pages/Morse"));
const Numeral = React.lazy(() => import("./pages/Numeral"));
const RomanoArabe = React.lazy(() => import("./pages/RomanoArabe"));
const Angular = React.lazy(() => import("./pages/Angular"));
const RM4SCC = React.lazy(() => import("./pages/RM4SCC"));

function App() {
  return (
    <Layout>
      <Suspense fallback={<LoadingSpinner />}>
        <Switch>
          <Route path="/" exact>
            <HomePage />
          </Route>

          <Route path="/privacidade" exact>
            <PrivacyPage />
          </Route>

          <Route path="/codigos" exact>
            <CodesPage />
          </Route>

          <Route path="/codigos/picos-de-morse" exact>
            <PicosMorse />
          </Route>

          <Route path="/codigos/transposto" exact>
            <Transposto />
          </Route>

          <Route path="/codigos/braile-falso" exact>
            <BraileFalso />
          </Route>

          <Route path="/codigos/braile-verdadeiro" exact>
            <BraileVerdadeiro />
          </Route>

          <Route path="/codigos/codigo-data" exact>
            <CodigoData />
          </Route>

          <Route path="/codigos/codigo-morse" exact>
            <Morse />
          </Route>

          <Route path="/codigos/alfabeto-numeral" exact>
            <Numeral />
          </Route>

          <Route path="/codigos/romano-arabe" exact>
            <RomanoArabe />
          </Route>

          <Route path="/codigos/codigo-angular" exact>
            <Angular />
          </Route>

          <Route path="/codigos/codigo-royal-mail" exact>
            <RM4SCC />
          </Route>

        </Switch>
      </Suspense>
    </Layout>
  );
}

export default App;
